export const COLORS = {
  PRIMARY: "#ff8038",
  PRIMARY_HOVER: "#e8722e",
  PRIMARY_LIGHT: "#ffe0b2",
  PRIMARY_ALPHA: "rgba(255, 128, 56, 0.04)",
  PRIMARY_SHADOW: "rgba(255, 128, 56, 0.15)",
  ERROR: "#d32f2f",
} as const;

export const VALIDATION_RANGES = {
  BOOST_VALUE: { min: 0, max: 100000 },
  PREFIX_LENGTH: { min: 0, max: 100 },
  MAX_EXPANSIONS: { min: 1, max: 1000 },
  SLOP: { min: 0, max: 100 },
  MINIMUM_SHOULD_MATCH: { min: 1, max: 50 },
} as const;

export const VALIDATION_MESSAGES = {
  MUST_BE_NUMBER: "Must be a valid number",
  NEGATIVE_BOOST:
    "Must be 0 or greater (negative values will hurt search results)",
  HIGH_BOOST: "Should be 100000 or less (very high values can skew results)",
  INVALID_FUZZINESS:
    "Must be one of: AUTO (recommended), 0 (exact match), 1 (1 character difference), 2 (2 character differences)",
  HIGH_PREFIX_LENGTH:
    "Should be 100 or less (high values make fuzzy search too strict)",
  LOW_EXPANSIONS: "Must be 1 or greater (at least one expansion needed)",
  HIGH_EXPANSIONS:
    "Should be 1000 or less (too many expansions slow down search)",
  HIGH_SLOP: "Should be 100 or less (very high values make phrases too loose)",
  MUST_BE_ZERO_OR_GREATER: "Must be 0 or greater",
  MUST_BE_ONE_OR_GREATER: "Must be 1 or greater",
  SHOULD_BE_100_OR_LESS: "Should be 100 or less",
  SHOULD_BE_50_OR_LESS: "Should be 50 or less",
} as const;

export const VALID_FUZZINESS_VALUES = ["AUTO", "0", "1", "2"] as const;

export const VALID_COMBINE_MODE_VALUES = ["max", "sum", "multiply"] as const;

export const VALID_BOOST_MODE_VALUES = [
  "replace",
  "multiply",
  "sum",
  "avg",
  "max",
  "min",
] as const;

export const VALIDATION_RULES = {
  boostConfig: {
    wildcard: { min: 0, max: 100000, step: 1 },
    fuzzy: { min: 0, max: 100000, step: 1 },
    termExact: { min: 0, max: 100000, step: 1 },
    termFirstWord: { min: 0, max: 100000, step: 1 },
    termGeneral: { min: 0, max: 100000, step: 1 },
    match: { min: 0, max: 100000, step: 1 },
    prefix: { min: 0, max: 100000, step: 1 },
    multiMatch: { min: 0, max: 100000, step: 1 },
    matchPhrase: { min: 0, max: 100000, step: 1 },
    matchPhrasePrefix: { min: 0, max: 100000, step: 1 },
  },
  fuzzyConfig: {
    fuzziness: { options: VALID_FUZZINESS_VALUES },
    prefixLength: { min: 0, max: 100, step: 1 },
    maxExpansions: { min: 1, max: 1000, step: 1 },
    transpositions: { type: "boolean" as const },
  },
  matchPhraseConfig: {
    slop: { min: 0, max: 100, step: 1 },
  },
  matchPhrasePrefixConfig: {
    slop: { min: 0, max: 100, step: 1 },
    maxExpansions: { min: 1, max: 1000, step: 1 },
  },
  minimumShouldMatch: { min: 1, max: 50, step: 1 },
  scriptScoreConfig: {
    enable: { type: "boolean" as const },
    exactMatchMultiplier: { min: 1, max: 10000, step: 0.1 },
    startsWithMultiplier: { min: 1, max: 10000, step: 0.1 },
    containsBase: { min: 0, max: 1000, step: 0.1 },
    combineMode: { options: VALID_COMBINE_MODE_VALUES },
    maxBoostCap: { min: 1, max: 100000, step: 0.1 },
    boundaryBonus: { min: 1, max: 100, step: 0.1 },
  },
  boostMode: {
    options: VALID_BOOST_MODE_VALUES,
  },
} as const;
